
  import { css } from 'lit';
  export const styles = css`:host{--ig-theme: material;--ig-theme-variant: dark}`;
  